export default {"src":"/_next/static/media/fsd_logo_canada.fbacfee4.svg","height":610,"width":1500,"blurWidth":0,"blurHeight":0};